import React from 'react';
import { Link, matchPath, useLocation } from 'react-router';
import { Layout, Menu } from 'antd';
import logo from '../../images/klickly-logo-white.svg';
import './index.scss';

export const SiderMenu = ({ menus, mapPathToKey = {} }) => {
    const location = useLocation();
    const pathname = location.pathname;

    const generateSubmenuTitle = (menu) => {
        return (
            <span>
                {menu.icon}
                <span>{menu.text}</span>
            </span>
        );
    };

    const generateMenu = (menus) => {
        return menus.map((menu) => {
            if (menu.sublinks) {
                return {
                    key: menu.menuTab,
                    label: generateSubmenuTitle(menu),
                    children: generateMenu(menu.sublinks)
                };
            }
            if (menu.divider) {
                return {
                    type: 'divider',
                    className: 'divider-space'
                };
            }

            let link;
            if (menu.href) {
                link = (
                    <a href={menu.href} target={menu.target || '_self'}>
                        {menu.icon}
                        <span>{menu.text}</span>
                    </a>
                );
            } else {
                link = (
                    <Link to={menu.link}>
                        {menu.icon}
                        <span>{menu.text}</span>
                    </Link>
                );
            }

            return {
                key: menu.menuTab,
                label: link
            };
        });
    };

    const defaultOpenKeys = (menus) => {
        return menus.reduce((acc, menu) => {
            if (menu.sublinks) {
                acc.push(menu.menuTab);
            }
            return acc;
        }, []);
    };

    const getSelectedItem = () => {
        const currentLocation = pathname.split('/')[2] || pathname.split('/')[1];
        for (const [key, value] of Object.entries(mapPathToKey)) {
            if (matchPath({ path: key, caseSensitive: false, end: true }, pathname)) {
                return value;
            }
        }
        return currentLocation;
    };

    return (
        <Layout.Sider role='navigation' aria-label='Section navigation'>
            <div className='logo'>
                <img src={logo} alt='Klickly admin' className='logo__img' />
            </div>
            <Menu
                className='left-menu'
                theme='dark'
                mode='inline'
                selectedKeys={[getSelectedItem()]}
                defaultOpenKeys={defaultOpenKeys(menus)}
                items={generateMenu(menus)}
            />
        </Layout.Sider>
    );
};
